<template>
  <v-card class="text-center" :flat="showCancel">
    <v-btn
      v-if="showCancel"
      small
      fab
      color="secondary"
      @click="$emit('cancel')"
      absolute
      class="close-btn"
      width="24"
      height="24"
    >
      <v-icon size="18">close</v-icon>
    </v-btn>
    <v-row>
      <v-col
        cols="auto"
        class="pl-6 text-left subtitle-2 lighttext--text my-auto"
      >
        <v-icon class="mr-2" color="lighttext" small>event</v-icon>
        {{ recognition.createdDate | longDate }}
      </v-col>
      <v-spacer></v-spacer>
      <v-tooltip bottom :disabled="recognition.likes.length == 0">
        <template v-slot:activator="{ on, attrs }">
          <v-col
            v-bind="attrs"
            v-on="on"
            cols="auto"
            class="pr-6 my-auto cursor-pointer"
            @click="like"
            @mouseover="likeHover = true"
            @mouseleave="likeHover = false"
          >
            <v-icon :color="likeColor" small class="mr-2">thumb_up</v-icon>
            <span :class="likeColor + '--text'">
              {{ recognition.likes.length }}
            </span>
          </v-col>
        </template>
        <div class="tooltip-limit-width">
          <div v-for="(name, i) in recognition.likes" :key="i">
            {{ name }}
          </div>
        </div>
      </v-tooltip>
    </v-row>
    <v-divider> </v-divider>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-badge color="transparent" overlap offset-x="40">
            <template v-slot:badge="{}">
              <v-avatar color="white" size="35" class="elevation-4">
                <v-img :src="$images.RECOGNITION_AVATAR"></v-img>
              </v-avatar>
            </template>
            <user-avatar
              :size="100"
              :user="recognition.user"
              color="background"
              borderColor="background"
              textColor="secondary"
              cssClass="halo text-h3"
              borderStyle="12"
            ></user-avatar>
          </v-badge>
        </v-col>
        <v-col cols="12">
          <v-card-title class="d-block py-0">
            {{ recognition.user.fullName }}
          </v-card-title>
        </v-col>
        <v-col
          cols="12"
          class="font-italic secondarytext--text white-space-pre-line"
        >
          "{{ recognition.text }}"
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text class="py-0">
      <v-row>
        <template v-if="hasCoreValue">
          <v-col cols="6" class="mr-n1 subtitle-1">
            <v-col cols="12">
              <avatar
                :avatarUrl="recognition.badgeUrl"
                size="50"
                cssClass="mx-auto"
              ></avatar>
            </v-col>
            Recognized for
            <div class="primary--text font-weight-bold">
              {{ recognition.coreValueName }}
            </div>
          </v-col>
          <v-divider vertical></v-divider>
        </template>
        <v-col
          :cols="hasCoreValue ? 6 : 12"
          :class="{ 'ml-n1': hasCoreValue, 'subtitle-1': true }"
        >
          <v-col cols="12">
            <user-avatar
              :size="50"
              :user="recognition.createdBy"
              cssClass="mx-auto"
            ></user-avatar>
          </v-col>
          Recognized by
          <div class="primary--text font-weight-bold">
            {{ recognition.createdBy.fullName }}
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "RecognitionCard",
  props: {
    recognition: { type: Object },
    showCancel: { type: Boolean, default: false }
  },
  data: () => ({ likeHover: false }),
  computed: {
    likeColor() {
      return this.recognition.likedByCurrentUser || this.likeHover
        ? "info"
        : "lighttext";
    },
    hasCoreValue() {
      return this.recognition.isMission || this.recognition.coreValueId;
    }
  },
  methods: {
    like() {
      this.$store
        .dispatch(
          this.recognition.likedByCurrentUser
            ? "recognition/unlikeRecognition"
            : "recognition/likeRecognition",
          this.recognition.id
        )
        .then(() => {
          this.$emit("save");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while liking a recognition."
          );
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.close-btn {
  right: -10px;
  top: -10px;
}
</style>
